<template>
  <div id="chat_list">
    <div class="chat_list_main">
      <div class="tabbar">
        <div
          :class="item.name === activeName ? 'isAcitve' : ''"
          v-for="item in chatTabs"
          :key="item.name"
          @click="clickTab(item.name)">
          {{ item.label }}
        </div>
        <span class="all_read" @click="goAllRead">
          <i class="iconfont icon-read-all"></i>
          全部已读
        </span>
      </div>
      <div class="chat_list" v-if="totalCount !== 0">
        <div class="put_top" v-if="activeName == 0&&topShow">置顶</div>
        <!-- <div class="chat_list_item put_top_item"
            v-for="(item,index) in putTopData.slice((currentPage-1)*PageSize,currentPage*PageSize)"
            :key="item.id"
            @click="enterRoom(item,index)">
          <div class="item_img">
            <img v-if="item.avtar" :src="item.avtar" alt="">
            <img v-else src="@/assets/image/chat/active.jpg" alt="">
          </div>
          <div class="item_content">
            <div class="IC_name">
              <div :class="item.type == 1 ? 'IC_tag_1 IC_tag' : '' ">
                {{ item.type == 1 ? '群聊' : '' }}
              </div>
              <div id="IC_tagName">{{ item.name }}</div>
              <div class="item_num" v-show="item.type !== 2">（{{ item.num }}人）</div>
            </div>
            <div class="IC_msg">
              {{ item.msg_sender }}：{{item.message}}
            </div>
          </div>
          <div class="item_date">
            <span v-if="item.msg_time !=0">
               {{ $formatDate(item.msg_time,'YYYY/MM/DD hh:mm:ss') }}
            </span>
          </div>
          <div class="item_state">
            <el-tag v-if="item.unread > 0 " type="danger" size="medium" effect="dark">+{{
                item.unread >= 100 ? 99 : item.unread
              }}
            </el-tag>
            <el-tag v-else type="info" size="medium">已读</el-tag>
          </div>
        </div> -->
        <div class="chat_list_item" :class="item.topstatus == 1?'put_top_item':''"
            v-for="(item,index) in putTopData.slice((currentPage-1)*PageSize,currentPage*PageSize)"
            :key="item.id"
            @click="enterRoom(item,index)">
          <div class="item_img" :class="item.sessionstatus == 0?'offline':''">
            <img v-if="item.headimg&&item.type == 1" :src="item.headimg" alt="">
            <img v-else :src="item.type == 1 ? require('@/assets/image/CustomerSer/WechatIMG.png'):require('@/assets/image/CustomerSer/qun.png')" alt="">
          </div>
          <div class="item_content">
            <div class="IC_name">
              <div :class="item.type == 3||item.type == 2 ? 'IC_tag_1 IC_tag' : '' ">
                {{ item.type == 3||item.type == 2 ? '群聊' : '' }}
              </div>
              <div id="IC_tagName">{{ item.title }}</div>
              <!-- <div class="item_num" v-show="(item.type == 3||item.type == 2)&&item.num">（{{ item.orderStatus?item.num: Number(item.num)-1 }}人）</div> -->
            </div>
            <div class="IC_msg">
              <span v-if="item.aite==1" style="color:#FF7272;font-weight:500;font-size:12px;">[有人@我]</span>
              {{regContent(item)}}
            </div>
          </div>
          <div class="item_date">
            <span v-if="item.addtime !=0">
               {{ formatDate(item.addtime,'YYYY/MM/DD HH:mm:ss') }}
            </span>
          </div>
          <div class="item_state">
            <el-tag v-if="item.unread > 0&&item.shieldstatus==0" type="danger" size="medium" effect="dark">{{
                item.unread >= 100 ? '+'+99 : '+'+item.unread
              }}
            </el-tag>
            <el-tag v-if="item.unread<=0" type="info" size="medium">已读</el-tag>
            <el-tag v-if="item.unread>0&&item.shieldstatus==1" type="info" size="medium">
              <el-badge is-dot>未读</el-badge>
            </el-tag>
          </div>
        </div>
        <div class="pages" v-if="totalCount !== 0">
          <common-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="PageSize"
            layout="prev, pager, next, jumper"
            :total="totalCount">
          </common-pagination>
        </div>
        <div></div>
      </div>
      <div class="chat_list no_data" v-else>
        <empty-state
          title="暂无消息"
          description="新的会话消息会展示在这里"
          icon="el-icon-chat-dot-round"
          :icon-size="52">
        </empty-state>
      </div>
    </div>
    <el-dialog
        :visible.sync="ICDialogVisible"
        custom-class="invitationCode"
        :show-close="false"
        top="35vh"
        center>
          <span>
            <div id="IC_main">
              <div class="IC_title">提示</div>
              <div class="IC_input">
                {{inviteUserInfo.content}}
              </div>
              <div class="IC_btn">
                <div @click="ICDialogVisible = false">取消</div>
                <div @click="roomJoin(inviteUserInfo.roomid)">确认</div>
              </div>
            </div>
            <img class="IC_close" src="@/assets/image/AccountDeal/close.png" alt="" @click="ICDialogVisible = false">
          </span>
    </el-dialog>
    <goCusSerCenter></goCusSerCenter>
  </div>
</template>
<script>
import chatApi from '@/request/customer/customerRoom'
import {Decrypt} from '@/request/customer/util.js'
import moment from 'moment/moment'
import goCusSerCenter from './components/goCusSerCenter.vue';
import {apiGetroomdetailbyroomid} from "@/request/API"
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  props: {},
  components: {
    goCusSerCenter,
    CommonPagination,
    EmptyState
  },
  data() {
    return {
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 默认每页显示的条数（可修改）
      PageSize: 10,
      selectItem: '聊天室列表',
      tabbarItem: ['聊天室列表'],
      chatTabs: [
        { label: '全部消息', name: '0' },
        { label: '客服', name: '2' },
        { label: '群聊', name: '1' }
      ],
      activeName: '0',
      tableData: [],
      putTopData: [],
      //分页页码
      pages: 1,
      //输入邀请码弹窗
      ICDialogVisible: false,
      topShow: false,
      inviteUserInfo: {},
      roomUser: [],
      roomidList: [],
    }
  },
  created() {
    this.initWebSocket()
  },
  methods: {
    clickTab(name) {
      if(this.activeName === name) return
      this.activeName = name
      this.currentPage = 1
      this.getDataList()
    },
    //屏蔽手机号
    regContent(item){
      let reg = /(\d{3})\d{4}(\d{4})/; //正则表达式
      let regPhone=/^(?:(?:\+|00)86)?1\d{10}$/
      if(!this.isMe(item.userid) && regPhone.test(item.content)&&item.msgtype!=1){
        item.content=item.content.replace(reg, "$1****$2")
      }
      return item.content
    },
    /**
     * @description: 全部已读
     * @return {*}
     */
    goAllRead() {
      chatApi.allreadback({
        format: 'json',
      }).then(res => {})
      // for (const key in this.tableData){
      //   this.tableData[key].unreadList = []
      //   if(this.tableData[key].unread){
      //     await chatApi.query({
      //       format: 'json',
      //       msgtype: '[1,2,3,10]',
      //       pagesize: this.tableData[key].unread,
      //       roomid: this.tableData[key].id,
      //       sort: "desc",
      //     }).then(res => {
      //       let resData = JSON.parse(JSON.parse(Decrypt(res.msg)).list)
      //       if(Object.keys(resData).length > 0){
      //         resData.forEach(item => {
      //           if(item.shouldusers){
      //             item.shouldusers.forEach(v => {
      //               if(v.userid == this.$store.state.userData.telphone){
      //                 this.tableData[key].unreadList.push(item.id)
      //               }
      //             })
      //           }else{
      //             this.tableData[key].unreadList.push(item.id)
      //           }

      //           // this.tableData[key].unreadList.push(item.id)
      //         })
      //       }
      //     })
      //     if(this.tableData[key].unreadList.length>0){
      //       chatApi.readback({
      //         format: 'json',
      //         ids: JSON.stringify(this.tableData[key].unreadList),
      //         roomid: this.tableData[key].id
      //       }).then(res => {
      //         this.tableData[key].unread = 0
      //         // this.getDataList()
      //       })
      //     }

      //   }
      // }
    },
    /**
     * @description: 获取聊天token
     * @return {*}
     */
    getCusToken() {
      chatApi.getToken({
        format: "json",
        type: 2,
        userid: this.$store.state.userData.telphone,
      }).then(res => {
        localStorage.setItem('cusetomerTokens', JSON.parse(Decrypt(res.msg)).token)
        this.initWebSocket()
      })
    },
    initWebSocket() {
      if(localStorage.getItem('cusetomerTokens') !== null && localStorage.getItem('cusetomerTokens') !== ''){
        this.$WSIM.createSocket()
        this.$WSIM.on('loginok',(e) => {
          localStorage.setItem('cusetomerSid', e.data.sid)
          // this.roomCreatCus()
        })
        this.$WSIM.on('createroom',(e) => {
          localStorage.setItem('roomId', e.data.id)
          this.selectRoomList()
        })
        this.$WSIM.on('shield',(e) => {
          this.getStationList()
        })
        this.$WSIM.on('top',(e) => {
          this.getStationList()
        })
        // 关闭房间同步
        this.$WSIM.on('close',(e) => {
          this.getStationList()
        })
        // 修改群名同步
        this.$WSIM.on('updatetitle',(e) => {
          let upaRoom = this.tableData.findIndex(item => item.id == e.data.roomid)
          this.$set(this.tableData[upaRoom],'title',e.data.title)
        })
        this.$WSIM.on('chat',(e) => {
          let value = e.data
          if(value.msgtype == 15){
            let con = JSON.parse(value.content)
            let cust = con.content.split('创建');
            if(con.userid.indexOf(this.$store.state.userData.telphone)!=-1){
              value.content = cust[0]
              this.inviteUser(value)
            }
          }
          if(value.msgtype == 16){
            let con = JSON.parse(value.content)
            let cust = con.content.split('邀请');
            if(con.userid.indexOf(this.$store.state.userData.telphone)!=-1){
              value.content = cust[0]
              this.inviteUser(value)
            }else{
              // let tabIndex = this.tableData.findIndex(item => item.id == value.roomid)
              // chatApi.querymember({
              //   format: 'json',
              //   roomid: value.roomid
              // }).then(re =>{
              //   let res_data = JSON.parse(Decrypt(re.msg))
              //   let list = JSON.parse(res_data.list)
              //   this.roomUser = list
              //   let numRoomUser = []
              //   list.forEach(item => {
              //     if(item.isdel == 0){
              //       numRoomUser.push(item)
              //     }
              //   })
              //   if(this.tableData[tabIndex].type == 3||this.tableData[tabIndex].type == 2){
              //     this.$set(this.tableData[tabIndex],'num',numRoomUser.length)
              //   }
              // })
              value.content = con.content
              value.contenttype = 1
              this.pushMsg(value)
            }
          }
          // 解散群聊
          if(value.msgtype == 17){
            let room = this.tableData.find(item => item.id == value.roomid)
            this.$message.info('群聊'+room.title+'已解散')
            let tabIndex = this.tableData.findIndex(item => item.id == value.roomid)
            this.tableData.splice(tabIndex,1)
            this.getDataList()
            this.ICDialogVisible = false
          }
          // 踢出群成员
          if(value.msgtype == 19){
            let con = JSON.parse(value.content)
            let tabIndex = this.tableData.findIndex(item => item.id == value.roomid)
            if(con.userid == this.$store.state.userData.telphone){
              let room = this.tableData.find(item => item.id == value.roomid)
              this.$message.info('您已被踢出'+room.title)
              this.tableData.splice(tabIndex,1)
              this.getDataList()
            }else{
              // chatApi.querymember({
              //   format: 'json',
              //   roomid: value.roomid
              // }).then(re =>{
              //   let res_data = JSON.parse(Decrypt(re.msg))
              //   let list = JSON.parse(res_data.list)
              //   this.roomUser = list
              //   let numRoomUser = []
              //   list.forEach(item => {
              //     if(item.isdel == 0){
              //       numRoomUser.push(item)
              //     }
              //   })
              //   if(this.tableData[tabIndex].type == 3||this.tableData[tabIndex].type == 2){
              //     this.$set(this.tableData[tabIndex],'num',numRoomUser.length)
              //   }
              // })
              value.content = con.content
              value.contenttype = 1
              this.pushMsg(value)
            }
            this.ICDialogVisible = false
          }
          if(value.msgtype == 20){
            let con = JSON.parse(value.content)
            value.contenttype = 1
            value.content = con.content
            this.pushMsg(value)
          }
          if(value.msgtype == 1||value.msgtype == 2||value.msgtype == 3||value.msgtype == 10||value.msgtype == 11||value.msgtype == 12||value.msgtype == 5||value.msgtype == 8||value.msgtype == 9||value.msgtype == 18){
            // let nick = this.roomUser.find(v => v.userid == value.userid)
            // value.nickname = nick.nickname
            // this.getStationList()
            this.pushMsg(value)
          }
        })
        this.$WSIM.on('offline',(e) => {
          let value = e.data.type
          if(value == 1){
            this.getStationList()
            // this.$message.info('当前客服已离线！')
            // this.selectRoomList()
          }
        })
        this.$WSIM.on('online',(e) => {
          let value = e.data.type
          if(value == 1){
            this.getStationList()
            // this.$message.info('客服'+ this.nickname +'已上线！')
            // this.selectRoomList()
          }
        })
        // 已读同步
        this.$WSIM.on('roomread',(e) => {
          for (const key in this.tableData) {
            if(this.tableData[key].id == e.data.roomid){
              // if(e.data.userid!=this.$store.state.userData.telphone){
                this.$set(this.tableData[key],'unread','0')
                this.$set(this.tableData[key],'aite',0)
              // }
            }
          }
        })
        this.$WSIM.on('recall',(e) => {
          let recall_id = e.data
          this.recreadCall(recall_id)
        })
      }else {
        this.getCusToken()
      }
    },
    /**
     * @description: 添加会话信息
     * @return {*}
     */
    pushMsg(msg) {
      if(this.roomidList.indexOf(msg.roomid) == -1){
        this.getStationList()
      }
      for (const key in this.tableData) {
        if(this.tableData[key].id == msg.roomid){
          this.$set(this.tableData[key],'addtime',msg.addtime)
          if(msg.userid!=this.$store.state.userData.telphone){
            this.$set(this.tableData[key],'unread',++this.tableData[key].unread)
          }
          if(msg.userid==this.$store.state.userData.telphone){
            this.$set(this.tableData[key],'unread',0)
          }
          if(msg.contenttype == 1){
            this.$set(this.tableData[key],'content',msg.content)
          } else if(msg.contenttype == 3||msg.contenttype == 4||msg.contenttype == 5){
            this.$set(this.tableData[key],'content','[图片]')
          } else if(msg.contenttype == 6) {
            this.$set(this.tableData[key],'content','[文件]')
          } else if(msg.contenttype == 10) {
            this.$set(this.tableData[key],'content','[聊天记录]')
          } else if(msg.contenttype == 9){
            let content = JSON.parse(msg.content)
            msg.content = content.content
            this.$set(this.tableData[key],'content',msg.content)
            if(content.userlist.indexOf(this.$store.state.userData.telphone)!=-1){
              this.$set(this.tableData[key],'aite',1)
            }
          }
        }
      }
      this.putTopData = this.putTopData.sort((a, b) => {
        if (a.topstatus === b.topstatus) {
          if (a.addtime && b.addtime && a.addtime !== b.addtime) {
            return b.addtime - a.addtime;
          }
        } else {
          return b.topstatus - a.topstatus;
        }
      })
    },
    recreadCall(msg) {
      for (const key in this.tableData) {
        if(this.tableData[key].id == msg.roomid){
          this.$set(this.tableData[key],'content','撤回了一条消息')
        }
      }
    },
    /**
     * @description: 邀请进入群聊
     * @return {*}
     */
    inviteUser(v) {
      let qun_title = ''
      chatApi.querymember({
        format: 'json',
        roomid: v.roomid
      }).then(res =>{
        let res_data = JSON.parse(Decrypt(res.msg))
        if(res_data.type == 3){
          // 群聊
          qun_title = res_data.title
          this.inviteUserInfo.content = v.content+'已经邀您进入群聊【'+qun_title+'】，是否直接开始对话？'
          this.inviteUserInfo.roomid = v.roomid
          this.ICDialogVisible = true
          this.getStationList()
        }
      })
    },
    getDataList() {
      if(this.activeName == 0){
        let toparr = []
        let notoparr = []
        this.roomidList = []
        for (const k in this.tableData) {
          if(this.tableData[k].shieldstatus == 1){
            // this.tableData[k].unread = 0
          }
          if(this.tableData[k].topstatus == 1&&this.tableData[k].status == 0){
            toparr.push(this.tableData[k])
            this.roomidList.push(this.tableData[k].id)
          }
          if(this.tableData[k].topstatus == 0&&this.tableData[k].status == 0){
            notoparr.push(this.tableData[k])
            this.roomidList.push(this.tableData[k].id)
          }
        }
        this.putTopData = [...toparr,...notoparr]
        this.topShow = toparr.length>0?true:false
        this.totalCount = this.putTopData.length
      }
      if(this.activeName == 2){
        let arr = []
        for (const k in this.tableData) {
          if(this.tableData[k].type == 1){
            arr.push(this.tableData[k])
          }
        }
        this.putTopData = [...arr]
        this.totalCount = this.putTopData.length
      }
      if(this.activeName == 1){
        let qun = []
        for (const k in this.tableData) {
          if(this.tableData[k].type == 3||this.tableData[k].type == 2){
            qun.push(this.tableData[k])
          }
        }
        this.putTopData = [...qun]
        this.totalCount = this.putTopData.length
      }
    },
    /**
     * @description: 13位时间戳转时间
     * @param {*} time
     * @param {*} format
     * @return {*}
     */
    formatDate(time, format) {
      if(!time) return ''
      format = format || 'YYYY-MM-DD HH:mm:ss';
      return moment(time).format(format);
    },
    //分页监听事件
    handleCurrentChange(val) {
      this.currentPage = val
    },

    //加入房间
    enterRoom(item, index) {
      let routeUrl = this.$router.resolve({
        name: 'chatRoom',
        query: {
          room_id: item.id,
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    /**
     * 获取 站内通知 列表
     * @param page 当前页码
     */
    getStationList(page) {
      this.roomUser = []
      chatApi.getsessionlistbycustomer({
        msg: chatApi.encryptMsg({
          format: 'json',
          customerid: this.$store.state.userData.telphone,
        })
      }).then(res => {
        let data = JSON.parse(Decrypt(res.result))
        this.tableData = data
        // 最后一条消息数组
        let lastMsgArr = []
        this.tableData.forEach(item => {
          if(item.lastchatid){
            lastMsgArr.push(item.lastchatid)
          }
        })
          chatApi.query({
            format: 'json',
            ids: JSON.stringify(lastMsgArr),
            // msgtype: '[1,2,3,8,9]',
            // roomid: this.tableData[key].id,
            pagesize: lastMsgArr.length,
            sort: "desc",
          }).then(response => {
            let lastData = JSON.parse(JSON.parse(Decrypt(response.msg)).list)
              if(Object.keys(lastData).length > 0){
                for (const key in this.tableData){
                  // chatApi.querymember({
                  //   format: 'json',
                  //   roomid: this.tableData[key].id
                  // }).then(async re =>{
                  //   let res_data = JSON.parse(Decrypt(re.msg))
                  //   let list = JSON.parse(res_data.list)
                  //   this.roomUser = list
                  //   let numRoomUser = []
                  //   list.forEach(item => {
                  //     if(item.isdel == 0){
                  //       numRoomUser.push(item)
                  //     }
                  //   })
                  //   if(this.tableData[key].type == 3||this.tableData[key].type == 2){
                  //     try {
                  //       await apiGetroomdetailbyroomid({
                  //         room_id: this.tableData[key].id,
                  //         client: 'front'
                  //       }).then(rre => {
                  //         this.$set(this.tableData[key],'orderStatus',rre.data.orderStatus?true:false)
                  //       }).catch(() => {
                  //       })
                  //     } catch {}
                  //     this.$set(this.tableData[key],'num',numRoomUser.length)
                  //   }
                  // })
                  for (const k in lastData){
                    if(this.tableData[key].id == lastData[k].roomid){
                      this.$set(this.tableData[key],'addtime',lastData[k].addtime)
                      if(lastData[k].contenttype == 1){
                        if(lastData[k].status == 1){
                          this.$set(this.tableData[key],'content',lastData[k].content)
                        }else{
                          this.$set(this.tableData[key],'content','撤回了一条消息')
                        }
                      } else if(lastData[k].contenttype == 3||lastData[k].contenttype == 4||lastData[k].contenttype == 5){
                        this.$set(this.tableData[key],'content','[图片]')
                      } else if(lastData[k].contenttype == 6) {
                        this.$set(this.tableData[key],'content','[文件]')
                      } else if(lastData[k].contenttype == 7) {
                        this.$set(this.tableData[key],'content',lastData[k].msgtype==23?'':lastData[k].msgtype==24?'[催一催消息]':JSON.parse(lastData[k].content).content)
                      } else if(lastData[k].contenttype == 9){
                        let content = JSON.parse(lastData[k].content)
                        lastData[k].content = content.content
                        this.$set(this.tableData[key],'content',lastData[k].content)
                        if(content.userlist.indexOf(this.$store.state.userData.telphone)!=-1){
                          this.$set(this.tableData[key],'aite',1)
                        }
                      } else if(lastData[k].contenttype == 10) {
                        this.$set(this.tableData[key],'content','[聊天记录]')
                      }
                    }
                  }
                }
              }
          })
        chatApi.queryatmsgrelation({
          msg: chatApi.encryptMsg({
            customerid: this.$store.state.userData.telphone,
            format: 'json',
          })
        }).then(res => {
          let aite_data = JSON.parse(Decrypt(res.result)).list
          // console.log('$$',aite_data);
          if(aite_data.length>0){
            aite_data.forEach(item => {
              for (const key in this.tableData) {
                if(this.tableData[key].id == item.roomid){
                  this.$set(this.tableData[key],'aite',1)
                }
              }
            })
          }
        }).catch()
        let is_unread = this.tableData.find(item => item.unread>0)
        // console.log(is_unread);
        if(is_unread){
          this.$store.commit('set_message', 1)
        }
        this.getDataList()
      })
    },
    isMe(id) {
      return id == this.$store.state.userData.telphone
    },
    /**
     * 买卖双方加入房间
     */
    roomJoin(id) {
      let routeUrl = this.$router.resolve({
        name: 'chatRoom',
        query: {
          room_id: id,
        }
      });
      this.ICDialogVisible = false
      window.open(routeUrl.href, '_blank');
    },
  },
  mounted() {
    //初始化数据
    this.getStationList(1)
    // let _this = this
    // let hiddenProperty = 'hidden' in document ? 'hidden' :
    // 'webkitHidden' in document ? 'webkitHidden' :
    // 'mozHidden' in document ? 'mozHidden' :
    // null;
    // let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange');
    // let onVisibilityChange = function(){
    //   if (!document[hiddenProperty]) {
    //     _this.getStationList(1)
    //     console.log('页面激活');
    //   }else{
    //     console.log('页面非激活')
    //   }
    // }
    // document.addEventListener(visibilityChangeEvent, onVisibilityChange);
  },
  watch: {},
  computed: {}
}
</script>
<!-- 弹框 -->
<style lang="less">

.invitationCode {
  width: 358px;
  // height: 200px;
  background: #FFFFFF;
  border-radius: 4px;
  position: relative;
  overflow: visible;
  box-sizing: border-box;

  .el-dialog__body {
    padding: 20px 35px 29px;
    position: relative;

    #IC_main {
      display: flex;
      flex-direction: column;
      //align-items: center;
      position: relative;

      .IC_title {
        text-align: center;
        margin: 0 0 10px;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 28px;
      }

      .IC_input {
        margin: 0 0 20px;
      }

      .IC_btn {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: #000000;
        display: flex;
        justify-content: space-between;
        div{
          width: 136px;
          line-height: 36px;
          height: 36px;
          background: #FFDB51;
          border:1px solid #FFDB51;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }

    .IC_close {
      width: 30px;
      height: 30px;
      position: absolute;
      bottom: -40px;
      left: 164px;
      cursor: pointer;
    }
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-input__inner {
    height: 56px;
    background: #F4F4F4;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #000000;
  }
}

.IC_msg * {
  margin: 0;
}

.invitationCode {
  background: var(--bg-card, #FFFFFF);
  border-radius: 4px;
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-dialog__body {
    padding: 24px 30px 28px;

    #IC_main {
      .IC_title {
        color: var(--text-main, #111827);
        font-weight: 500;
      }

      .IC_input {
        color: var(--text-secondary, #5A5F6B);
        line-height: 22px;
      }

      .IC_btn {
        gap: 12px;

        div {
          width: 100%;
          border-radius: 4px;
          border-color: var(--border-soft, #E8E4DE);
          background: var(--bg-section, #F7F5F2);
          color: var(--text-secondary, #5A5F6B);
        }

        div:last-child {
          border: none;
          background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
          color: #FFFFFF;
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
        }
      }
    }
  }
}
</style>
<style lang='less' scoped>

#chat_list {
  padding: 0 19px;

  .chat_list_main {
    display: flex;
    flex-direction: column;

    .entrance {
      padding: 41px 0 43px 46px;
      border-bottom: 1px solid #e2e2e2;
      margin: 0 0 38px;

      .entrance_title {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 0 0 32px;

        span {
          display: inline-block;
          width: 3px;
          height: 12px;
          background: #000000;
          border-radius: 2px;
        }

        img {
          margin: 0 9px 0 16px;
          width: 28px;
          height: 24px;
        }

        div {
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
        }
      }

      .entrance_join {
        display: flex;
        flex-direction: row;
        align-items: center;

        /deep/ .el-dialog__header {
          padding: 0;
        }

        /deep/ .el-input__inner {
          width: 367px;
          height: 50px;
          background: #f7f7f7;
          border-radius: 4px;
          border: 1px solid #F0F0F0;
          font-size: 18px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 400;
          color: #000000;
          padding: 0 37px;
        }

        .entrance_input {
          width: 367px;
          height: 50px;
          background: #f7f7f7;
          border-radius: 4px;
          margin: 0 10px 0 0;
        }

        .entrance_btn {
          font-size: 19px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          line-height: 50px;
          width: 133px;
          height: 50px;
          background: #ff7272;
          border-radius: 4px;
          cursor: pointer;
        }
      }
    }

    .chat_title {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 30px 0 0 30px;
      margin: 0 0 15px 0;

      .all_read{
        flex: 1;
        margin-right: 20px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #000000;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;
        &::before{
          content: ' ';
          display: block;
          height: 20px;
          width: 20px;
          background: url("../../assets/image/PersonalCenter/SiteNotice/allRead.png") no-repeat;
          background-size: contain;
          margin-right: 5px;
        }
        &:hover{
          color: #FCAD13;
          &::before{
            background: url("../../assets/image/PersonalCenter/SiteNotice/alReadhover.png") no-repeat;
            background-size: contain;
          }
        }
      }

      img {
        margin: 0 10px 0 0px;
        width: 28px;
        height: 24px;
      }

      div {
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: #000000;
        line-height: 20px;
      }

    }

    .chat-tabs {
      background: #1A1D24;
      border-radius: 4px;
      padding: 0 46px;
      margin: 5px 0 10px 0;

      /deep/ .el-tabs__header {
        margin: 0;

        .el-tabs__active-bar {
          background-color: #f4a815;
        }

        .el-tabs__item {
          height: 50px;
          line-height: 50px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: CENTER;
          color: #ffffff;

          &.is-active {
            font-size: 20px;
            font-weight: 500;
          }
        }
      }

      /deep/ .el-tabs__nav-wrap::after {
        background-color: #1A1D24;
        bottom: 1px,
      }
    }

    .chat_list {
      display: flex;
      flex-direction: column;
      .put_top{
        height: 28px;
        background: #F8F8F8;
        line-height: 28px;
        text-indent: 13px;
      }
      .put_top_item{
        background: #F7F8FA;
      }
      .chat_list_item {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 15px 15px 15px 30px;
        border-bottom: 1px solid #E2E2E2;
        cursor: pointer;
        &:hover{
          background: #FFFAF0;
        }
        .item_img {
          width: 50px;
          height: 50px;
          margin: 0 10px 0 0;
          border-radius: 50%;
          overflow: hidden;
          position: relative;
          &.offline{
            -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
            filter: grayscale(100%);
            &::after{
              position: absolute;
              bottom: 0;
              left: 0;
              content: '离线';
              display: block;
              width: 50px;
              height: 18px;
              background: rgba(0, 0, 0, 0.35);
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 300;
              color: #FFFFFF;
              line-height: 18px;
              text-align: center;
              font-size: 12px;
            }
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .item_content {
          width: 300px;

          .IC_name {
            display: flex;
            flex-direction: row;
            align-items: center;

            .IC_tag {
              width: 51px;
              height: 22px;
              line-height: 22px;
              border-radius: 4px;
              box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: center;
              color: #ffffff;
            }

            .IC_tag_1 {
              background: #FFBD80;
            }

            // .IC_tag_2 {
            //   background: #11CB5B;
            // }

            // .IC_tag_3 {
            //   background: #F7F5F2;
            // }

            #IC_tagName {
              max-width: 180px;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: #282828;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin: 0 6px;
            }

            .item_num {
              min-width: 58px;
              font-size: 16px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: #5B5B5B;
              line-height: 22px;
            }
          }

          .IC_msg {
            margin-top: 6px;
            // display: flex;
            // align-items: center;
            width: 250px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Light;
            font-weight: 300;
            color: #a5acb4;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }


        .item_state {
          margin: 0 40px 0 60px;

          /deep/ .el-tag {
            width: 45px;
            text-align: center;
          }

          /deep/ .el-tag--info {
            background: #F0F0F0;
            border-radius: 4px;
            border: none;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #BFBFBF;
            line-height: 27px;
          }

          /deep/ .el-tag--warning {
            min-width: 45px;
            text-align: center;
            background: #FFF2D9;
            border-radius: 4px;
            border: none;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #FCAD13;
            line-height: 27px;
          }
        }

        .item_date {
          text-align: right;
          flex: 1;
          font-size: 16px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 300;
          color: #8F8F8F;
          line-height: 22px;
          width: 130px;
        }

        .item_btn {
          width: 110px;
          height: 40px;
          background: #ffdb51;
          border-radius: 4px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Light;
          font-weight: 300;
          text-align: CENTER;
          color: #000000;
          line-height: 40px;
          cursor: pointer;
        }
      }

      .pages {
        height: 94px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .no_data {
      height: 696px;
      display: flex;
      justify-content: center;
      align-items: center;

      #noData {
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
  }

}

#chat_list {
  padding: 20px;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .chat_list_main {
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .chat_title {
      min-height: 72px;
      padding: 22px 24px 12px;
      margin: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);

      img {
        width: 28px;
        height: 28px;
        margin-right: 10px;
        padding: 5px;
        border-radius: 4px;
        background: var(--brand-blue-light, #F0EDE8);
      }

      div {
        font-size: 18px;
        line-height: 26px;
        font-weight: 500;
        color: var(--text-main, #111827);
      }

      .all_read {
        height: 32px;
        margin-right: 0;
        padding: 0 12px;
        flex: 1;
        justify-content: flex-end;
        font-size: 14px;
        color: var(--brand-blue, #1A1D24);
        transition: color .2s ease, opacity .2s ease;

        &::before {
          width: 18px;
          height: 18px;
          margin-right: 6px;
          opacity: .78;
        }

        &:hover {
          color: var(--primary, #FF7A1A);
          opacity: .92;
        }
      }
    }

    .chat-tabs {
      margin: 0;
      padding: 14px 24px;
      background: var(--bg-card, #FFFFFF);
      border-radius: 0;

      /deep/ .el-tabs__header {
        margin: 0;
      }

      /deep/ .el-tabs__nav-wrap::after {
        display: none;
      }

      /deep/ .el-tabs__nav-scroll {
        overflow: visible;
      }

      /deep/ .el-tabs__nav {
        display: flex;
        gap: 8px;
      }

      /deep/ .el-tabs__active-bar {
        display: none;
      }

      /deep/ .el-tabs__item {
        height: 34px;
        line-height: 34px;
        padding: 0 16px !important;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
        transition: color .2s ease, background .2s ease, box-shadow .2s ease;

        &:hover {
          color: var(--brand-blue, #1A1D24);
          background: var(--brand-blue-light, #F0EDE8);
        }

        &.is-active {
          color: #FFFFFF;
          font-size: 14px;
          font-weight: 500;
          background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
        }
      }
    }

    .chat_list {
      min-height: 500px;
      background: var(--bg-card, #FFFFFF);

      .put_top {
        height: 32px;
        line-height: 32px;
        padding: 0 24px;
        text-indent: 0;
        background: var(--bg-section, #F7F5F2);
        border-top: 1px solid var(--border-soft, #E8E4DE);
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        font-size: 13px;
        color: var(--text-muted, #9AA0AC);
      }

      .put_top_item {
        background: linear-gradient(90deg, rgba(26, 29, 36, .06) 0%, rgba(255, 255, 255, 0) 70%);
      }

      .chat_list_item {
        min-height: 84px;
        padding: 16px 24px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        transition: background .2s ease;

        &:hover {
          background: var(--bg-section, #F7F5F2);
        }

        .item_img {
          flex-shrink: 0;
          width: 52px;
          height: 52px;
          margin-right: 16px;
          border-radius: 4px;
          background: var(--bg-card-soft, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);

          &.offline {
            filter: grayscale(100%);

            &::after {
              width: 52px;
              height: 18px;
              line-height: 18px;
              background: rgba(15, 23, 42, .48);
              font-weight: 400;
            }
          }

          img {
            border-radius: 4px;
          }
        }

        .item_content {
          min-width: 0;
          width: 360px;
          flex: 0 1 420px;

          .IC_name {
            min-width: 0;
            height: 24px;

            .IC_tag {
              width: auto;
              min-width: 42px;
              height: 22px;
              padding: 0 8px;
              line-height: 22px;
              flex-shrink: 0;
              border-radius: 4px;
              box-shadow: none;
              color: var(--brand-blue, #1A1D24);
              background: var(--brand-blue-light, #F0EDE8);
            }

            .IC_tag_1 {
              background: var(--brand-blue-light, #F0EDE8);
            }

            #IC_tagName {
              min-width: 0;
              max-width: 280px;
              margin: 0 0 0 8px;
              font-size: 15px;
              line-height: 22px;
              font-weight: 500;
              color: var(--text-main, #111827);
            }
          }

          .IC_msg {
            width: 100%;
            margin-top: 6px;
            font-size: 13px;
            line-height: 20px;
            font-weight: 400;
            color: var(--text-muted, #9AA0AC);
          }
        }

        .item_date {
          width: 170px;
          flex: 1;
          padding-left: 16px;
          font-size: 13px;
          line-height: 20px;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }

        .item_state {
          width: 64px;
          margin: 0 0 0 24px;
          display: flex;
          justify-content: flex-end;
          flex-shrink: 0;

          /deep/ .el-tag {
            width: auto;
            min-width: 44px;
            height: 26px;
            padding: 0 9px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: none;
            border-radius: 4px;
            font-size: 12px;
            line-height: 26px;
            font-weight: 500;
          }

          /deep/ .el-tag--danger {
            color: #FFFFFF;
            background: var(--danger, #EF4444);
          }

          /deep/ .el-tag--info {
            color: var(--text-muted, #9AA0AC);
            background: var(--bg-card-soft, #F0EDE8);
          }
        }
      }

      .pages {
        min-height: 88px;
        height: auto;
        padding: 0 0 24px;
      }
    }

    .no_data {
      min-height: 500px;
      height: auto;
    }
  }
}

#chat_list {
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  .chat_list_main {
    overflow: visible;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    overflow: visible;
    background: transparent;
    border: none;
    border-radius: 0;

    div {
      min-width: 84px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      background: transparent;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover {
      color: var(--brand-blue, #1A1D24);
      background: var(--brand-blue-light, #F0EDE8);
    }

    .isAcitve {
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
    }

    .isAcitve:hover {
      color: #FFFFFF;
      background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
    }

    .all_read {
      flex: 1;
      height: 34px;
      margin-right: 0;
      padding: 0;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--brand-blue, #1A1D24);
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      user-select: none;
      transition: color .2s ease;

      i {
        margin-right: 6px;
        font-size: 16px;
      }

      &:hover {
        color: var(--primary, #FF7A1A);
      }
    }
  }

  .chat_list_main .chat_list {
    min-height: 520px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    .put_top {
      height: 32px;
      line-height: 32px;
      padding: 0 22px;
      text-indent: 0;
      background: var(--bg-section, #F7F5F2);
      border-top: none;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      font-size: 13px;
      color: var(--text-muted, #9AA0AC);
    }

    .put_top_item {
      background: var(--bg-card, #FFFFFF);
    }

    .chat_list_item {
      min-height: 92px;
      padding: 18px 22px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      transition: background .2s ease;

      &:hover {
        background: var(--bg-section, #F7F5F2);
      }

      .chat-item-avatar,
      .item_img {
        flex-shrink: 0;
        width: 52px;
        height: 52px;
        margin-right: 16px;
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        background: var(--bg-card-soft, #F0EDE8);
      }

      .item_content {
        min-width: 0;
        width: auto;
        flex: 1 1 auto;

        .IC_name {
          min-width: 0;
          height: 24px;

          .IC_tag {
            width: auto;
            min-width: 42px;
            height: 22px;
            padding: 0 8px;
            line-height: 22px;
            flex-shrink: 0;
            border-radius: 4px;
            box-shadow: none;
            color: var(--brand-blue, #1A1D24);
            background: var(--brand-blue-light, #F0EDE8);
          }

          #IC_tagName {
            min-width: 0;
            max-width: 360px;
            margin: 0 0 0 8px;
            font-size: 15px;
            line-height: 22px;
            font-weight: 600;
            color: var(--text-main, #111827);
          }
        }

        .IC_msg {
          width: 100%;
          margin-top: 8px;
          font-size: 14px;
          line-height: 22px;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
        }
      }

      .item_date {
        width: 168px;
        flex: 0 0 168px;
        padding-left: 18px;
        font-size: 13px;
        line-height: 20px;
        font-weight: 400;
        color: var(--text-muted, #9AA0AC);
      }

      .item_state {
        width: 64px;
        margin: 0 0 0 18px;
        display: flex;
        justify-content: flex-end;
        flex-shrink: 0;
      }
    }

    .pages {
      min-height: 86px;
      height: auto;
      padding: 0 0 28px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .chat_list_main .no_data {
    min-height: 520px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
